export default {
      id: "ic_horse_white-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_horse_white-usage",
      toString: function () {
        return this.url;
      }
    }